import Vue from "vue";
import BoardMembers from "./BoardMembers.vue"

export function load() {
    const selector = "board-members";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(BoardMembers, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
